/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { ViewOptionsListProps } from '../view-options/types.tsx';
import parameters, {
	type ProjectsViewOptionsQuery,
} from './__generated__/ProjectsViewOptionsQuery.graphql';

type EntryPointParams = { cloudId: string } & ExtraProps;

type Queries = { projectsViewOptions: ProjectsViewOptionsQuery };
type ExtraProps = {} & ViewOptionsListProps;

type ProjectsViewOptionsEntrypointComponent = EntryPointComponent<Queries, {}, {}, ExtraProps>;

export const ProjectsViewOptionsEntrypoint: EntryPoint<
	ProjectsViewOptionsEntrypointComponent,
	EntryPointParams
> = createEntryPoint({
	root: JSResourceForInteraction<ProjectsViewOptionsEntrypointComponent>(
		/* webpackChunkName: "async-projects-view-options" */ './ProjectsViewOptions.tsx',
	),
	getPreloadProps: ({ cloudId, onChange }: EntryPointParams) => ({
		queries: {
			projectsViewOptions: {
				options: {
					fetchPolicy: 'store-and-network' as const,
				},
				parameters,
				variables: { cloudId },
			},
		},
		extraProps: { onChange },
	}),
});
